import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import * as socketIo from 'socket.io-client';
import { SessionService } from './session.service';
import { ConfigService } from './config.service';
import {User} from '../models/user.model';
import {Subject} from 'rxjs/Subject';
import { StorageService } from './storage.service';

declare var CryptoJS: any;
declare var JSEncrypt: any;

// const SERVER_URL = 'http://localhost:8080';
// const SERVER_URL = 'http://test-echo.eu-west-1.elasticbeanstalk.com';

@Injectable()
export class SocketService {
    private socket;
    private token: string;
    private publicKey = this.configService.get('adyen').publicKey;
    private randomString: string;
    public SERVER_URL;
    private userDomain: String;

    constructor (
        private sessionService: SessionService,
        private configService: ConfigService
    ) {
        this.SERVER_URL = configService.get('server').echo;
    }

    public initSocket(): void {
        this.userDomain = this.sessionService.getUserDomain();
        this.token = 'Bearer ' + this.sessionService.getToken();
        this.token =  this.encrypt(this.token);
        this.socket = socketIo.connect(this.SERVER_URL, {
            transports: [ 'polling', 'websocket' ],
            query: { token: this.token },
            reconnection : true,
            reconnectionDelay : 500,
            reconnectionAttempts: 10,
            origin: '*',
            extraHeaders: {
                headers: { 'Content-Type': 'application/json' }
            }
        });
    }

    public send(notification: any): void {
        this.socket.emit('notification', notification);
    }

    public onNotification(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('message', (data: any) => observer.next(data));
        });
    }

    public onEvent(event: any): Observable<any> {
        if(event === 'error') {
            return new Observable<any>(observer => {
                this.socket.on('error', function(err) {
                    observer.next(err)
                });
            });
        } else {
            return new Observable<any>(observer => {
                this.socket.on(event, () => {
                    if (event === 'connect') this.socket.emit('room', this.userDomain);
                    observer.next()});
            });
        }
    }
    public onDisconnect() {
        this.socket.close();
        console.log('closed')
    }

    private encrypt(details: any) {
        // Create a new encryption key (with a specified length)
        let key = this.generateKey(10);

        // convert data to a json string
        let dataAsString = JSON.stringify(details);

        // encrypt the data symmetrically
        // (the cryptojs library will generate its own 256bit key)
        let aesEncrypted = CryptoJS.AES.encrypt(dataAsString, key);

        // get the symmetric key and initialization vector from
        // (hex encoded) and concatenate them into one string
        let aesKey = aesEncrypted.key + ':::' + aesEncrypted.iv;

        // the data is base64 encoded
        let encryptedDetails = aesEncrypted.toString();

        // create a new JSEncrypt object for rsa encryption
        let rsaEncrypt = new JSEncrypt();

        // set the public key (which we passed into the function)
        rsaEncrypt.setPublicKey(this.publicKey);

        // encrypt the key & iv with public key
        let encryptedKey = rsaEncrypt.encrypt(aesKey);

        // and concatenate our payload message
        let payload = encryptedKey + ':::' + encryptedDetails;
        return payload
    };

    private generateKey(keyLength) {
        let chars = `0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmn
            opqrstuvwxyz*&-%/!?*+=()`;
        this.randomString = '';
        for (0; keyLength; 1) {
            let rnum = Math.floor(Math.random() * chars.length);
            this.randomString += chars.substring(rnum,rnum+1);
            if(this.randomString.replace(/\s/g, '').length == keyLength) return this.randomString.replace(/\s/g, '')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/core/services/socket.service.ts